// extracted by mini-css-extract-plugin
export var backdropBlur = "_b8-0";
export var body = "_b8-5";
export var bodyScroll = "_b8-6";
export var columnFooter = "_b8-7";
export var columnFooterFlush = "_b8-8";
export var contentColumn = "_b8-4";
export var frame = "_b8-3";
export var heroContent = "_b8-c";
export var heroOverlay = "_b8-b";
export var image = "_b8-a";
export var imageWrapper = "_b8-9";
export var modal = "_b8-1";
export var modalMain = "_b8-2";
export var productHeader = "_b8-d";
export var productHeaderIcon = "_b8-e";
export var productHeaderName = "_b8-f";
export var progressIndicator = "_b8-g";